<template>
  <!-- 公共查询模块 -->
  <Layout class="layout-wrapper projectDetailDockingQuery">
    <Header class="header-wrapper ajFlex">
      <Menu mode="horizontal" theme="dark" ref="navMenu" class="header-left">
        <div class="header-logo">建筑工人管理服务信息平台</div>
      </Menu>
    </Header>

    <div style="background: white; margin:88px 24px 0px; height: 200px">
      <div class="ft-box">
        <div
              class=" c-bread-wrapper"
              style="display: flex; justify-content: flex-start; margin:20px 5px; padding-left: 30px; padding-bottom: 5px;border-bottom: 1px solid  #F5F7F9"
            >
              <div
                v-if="$route.meta.title !== '数据统计'"
                style="padding: 0 12px 0 0; margin-right: 12px; border-right: 1px solid lightgray; cursor: pointer;"
                @click="handleBack"
              >
                <Icon
                  type="md-arrow-round-back"
                  style="font-size: 18px;margin-right: 6px;"
                />返回
              </div>
              <Breadcrumb class="c-bread aFlex">
                <BreadcrumbItem class="c-bread-item">
                  <span class="titleStyle">{{ $route.meta.title }}</span>
                </BreadcrumbItem>
              </Breadcrumb>
        </div>
        <div style="padding-left: 30px">
          <Form
            ref="projectForm"
            :model="projectForm"
            :rules="ruleValidate"
          >
           <Row :gutter="16">
              <Col :span="6">
            <FormItem prop="projectName" >
              <span class="red-asterisk">*</span>
              <Select
                v-model="projectForm.projectId"
                filterable
                :remote-method="getProjects"
                :loading="projectLoading"
                clearable
                placeholder="请输入项目名称关键字"
                style="width: 350px"
              >
                <Option
                  v-for="(option, index) in projects"
                  :value="option.projectId"
                  :key="index"
                  >{{ option.projectName }}</Option
                >
              </Select>
            </FormItem>
            </Col>
            <Col :span="6">
            <FormItem prop="token">
              <span class="red-asterisk">*</span>
              <Input
                type="text"
                v-model="projectForm.token"
                placeholder="请输入token校验"
                style="width: 350px"
                clearable
              ></Input>
            </FormItem>
            </Col>
             <Col :span="6">
            <FormItem prop="provider" >
              <span class="red-asterisk">*</span>
              <Input
                type="text"
                v-model="projectForm.provider"
                placeholder="请输入provider校验"
                style="width: 350px"
                clearable
              >
              </Input>
            </FormItem>
            </Col>
            </Row>
          </Form>
           <Row :gutter="16">
              <Col :span="24" style="margin-left: 16px">
                  <div>
                  <Button type="primary" size="large" @click="searchProject()" class="searchStyle"
                    >查询</Button
                  ><span class="fontColor">（该查询仅供获取到秘钥的项目进行数据对接情况查询。）</span>
                </div>
              </Col>
            </Row>
        </div>
      </div>
    </div>
    <div style="background: white; margin:20px 24px 0px; padding: 10px 30px" v-show="isformData">
      <div class="ft-box">
        <div class="ft-title aFlex">
          <Icon class="ft-title-mark" type="md-bookmark" />
          <span>项目基本信息</span>
        </div>
        <ul class="ft-form-wrapper">
          <li class="ft-form-item">
            <div class="ft-th">项目名称</div>
            <div class="ft-td ft-bold">{{ formData.projectName }}</div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">项目分类</div>
            <div class="ft-td">{{ formData.category }}</div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">建设单位</div>
            <div class="ft-td">
              <span>{{ formData.buildCorpName }}</span>
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">施工总承包单位</div>
            <div class="ft-td">
              <span class="link-span" style="font-weight: 700">{{
                formData.contractorCorpName
              }}</span>
            </div>
          </li>
          <li
            class="ft-form-item"
            :style="`${formData.buildNumFlag != 1 ? '' : 'width: 50%;'}`"
          >
            <div class="ft-th">施工许可证办理情况</div>
            <div class="ft-td">
              <Tag color="success" v-if="formData.buildNumFlag == 1"
                >已办理施工许可证</Tag
              >
              <Tag color="primary" v-else>正在办理施工许可证</Tag>
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">实名制情况</div>
            <div
              class="ft-td"
              :class="
                formData.sxRegState
                  ? formData.sxRegState == '1' ||
                    formData.sxRegState == '2' ||
                    formData.sxRegState == '3'
                    ? 'ft-green'
                    : 'ft-red'
                  : ''
              "
            >
              {{
                formData.sxRegState
                  ? formData.sxRegState == "1"
                    ? "已登记"
                    : formData.sxRegState == "2"
                    ? "已对接"
                    : formData.sxRegState == "3"
                    ? "已上传实名制数据"
                    : "未上传实名数据"
                  : "暂无"
              }}
            </div>
          </li>
          <li class="ft-form-item" style="width: 100%">
            <div class="ft-th">施工许可证编号</div>
            <div class="ft-td">{{ formData.builderLicenseNum }}</div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">项目状态</div>
            <div class="ft-td">
              <Tag color="success" v-if="formData.prjStatus === '在建'">{{
                formData.prjStatus
              }}</Tag>
              <Tag color="primary" v-else-if="formData.prjStatus === '完工'">{{
                formData.prjStatus
              }}</Tag>
              <Tag color="error" v-else-if="formData.prjStatus === '停工'">{{
                formData.prjStatus
              }}</Tag>
              <Tag color="primary" v-else>{{ formData.prjStatus }}</Tag>
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">项目联系人</div>
            <div class="ft-td">
              {{ formData.linkMan }}
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">建设性质</div>
            <div class="ft-td">
              {{ formData.propertyNumName }}
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">建设规模</div>
            <div class="ft-td">
              {{ formData.prjsizeName }}
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">工程用途</div>
            <div class="ft-td">
              {{ formData.functionNumName }}
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">开工/竣工时间</div>
            <div class="ft-td">
              {{
                (formData.startDate || "--") +
                " / " +
                (formData.completeDate || "--")
              }}
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">项目所在地</div>
            <div class="ft-td">
              {{ formData.areaName }}
            </div>
          </li>
          <li class="ft-form-item">
            <div class="ft-th">项目地点</div>
            <div class="ft-td">
              {{ formData.address }}
            </div>
          </li>
        </ul>
      </div>
      <Tabs value="1">
        <TabPane label="项目登记信息" name="1">
          <div class="ft-box">
            <ul class="ft-form-wrapper" v-if="formDataRegister">
              <li class="ft-form-item">
                <div class="ft-th">项目名称</div>
                <div class="ft-td ft-bold">{{ formDataRegister.name }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">施工许可证号</div>
                <div class="ft-td">{{ formDataRegister.buildPermitCode }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目所在地区</div>
                <div class="ft-td">
                  <span>{{ formDataRegister.areaName }}</span>
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目类别</div>
                <div class="ft-td">
                <span>{{
                  common.transfer(
                    formDataRegister.projectType,
                    common.projectTypes
                  )
                }}</span>
                </div>
              </li>
              <li class="ft-form-item" style="width: 100%">
                <div class="ft-th">项目状态</div>
                <div class="ft-td">
                <span>{{
                  common.transfer(formDataRegister.prjStatus, common.prjStatusS)
                }}</span>
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目开工日期（计划开工日期）</div>
                <div class="ft-td">
                  {{ formDataRegister.startDate }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目竣工日期（计划竣工日期）</div>
                <div class="ft-td">
                  {{ formDataRegister.completeDate }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">总投资（万元）</div>
                <div class="ft-td">
                  {{ formDataRegister.invest }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">总面积（平方米）</div>
                <div class="ft-td">
                  {{ formDataRegister.buildingArea }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">施工总承包单位名称</div>
                <div class="ft-td">
                  {{ formDataRegister.contractorCorpName }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">施工总承包单位统一社会信用代码</div>
                <div class="ft-td">{{ formDataRegister.contractorCorpCode }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目经理</div>
                <div class="ft-td">{{ formDataRegister.pmName }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">联系电话</div>
                <div class="ft-td">{{ formDataRegister.pmPhone }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">建设单位名称</div>
                <div class="ft-td">{{ formDataRegister.buildCorpName }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">建设单位统一社会信用代码</div>
                <div class="ft-td">{{ formDataRegister.buildCorpCode }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">建设单位项目负责人</div>
                <div class="ft-td">
                  {{ formDataRegister.supervisingEngineerName }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">联系电话</div>
                <div class="ft-td">
                  {{ formDataRegister.supervisingEngineerPhone }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">监理单位名称</div>
                <div class="ft-td">{{ formDataRegister.adminName }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">监理单位统一社会信用代码</div>
                <div class="ft-td">{{ formDataRegister.adminId }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目总监</div>
                <div class="ft-td">{{ formDataRegister.projectDirector }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">联系电话</div>
                <div class="ft-td">
                  {{ formDataRegister.projectDirectorPhone }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">设备安装公司名称</div>
                <div class="ft-td">
                  {{ formDataRegister.equipmentCompanyName }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">设备安装公司电话</div>
                <div class="ft-td">
                  {{ formDataRegister.equipmentCompanyMobile }}
                </div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目实名制负责人姓名</div>
                <div class="ft-td">{{ formDataRegister.applicantName }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目实名制负责人联系电话</div>
                <div class="ft-td">{{ formDataRegister.applicantMobile }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">项目实名制负责人邮箱</div>
                <div class="ft-td">{{ formDataRegister.email }}</div>
              </li>
              <li class="ft-form-item">
                <div class="ft-th">备注</div>
                <div class="ft-td">{{ formDataRegister.remark }}</div>
              </li>
            </ul>
            <span v-else>无项目登记信息</span>
          </div>
        </TabPane>
        <TabPane label="项目登记关键岗位人员信息" name="11">
          <div class="ft-box">
            <Table border size="large"
                   :columns="registerColumns" :data="registerInfo" highlight-row>
            </Table>
          </div>
        </TabPane>
        <TabPane label="项目推送关键岗位人员信息" name="12">
          <div class="ft-box">
            <div class="aFlex" style="padding-bottom: 8px;">
              <div class="aFlex " style="margin-left: auto">
                <Button icon="ios-exit-outline" type="primary" @click="handleWorkerExport">导出</Button>
                <div style="margin-left: 8px">考勤日期： </div>
                <DatePicker transfer
                            :value="workDate"
                            type="date"
                            placeholder="请选择一天"
                            @on-change="timeChange"
                >
                </DatePicker>
              </div>
            </div>
            <Table border size="large"
                   :loading="uploading"
                   :columns="uploadColumns" :data="uploadInfo" highlight-row>
              <template slot-scope="{ row, index }" slot="warningType">
                <span :class="{'warning': row.warningType !== '与项目登记信息一致'}">{{ row.warningType }}</span>
              </template>
              <template slot-scope="{ row, index }" slot="entryDate">
                <div>进场: {{ row.entryDate }}</div>
                <div>退场: {{ row.exitDate }}</div>
              </template>
            </Table>
          </div>
        </TabPane>
        <TabPane label="参建单位" name="2">
          <div class="ft-box">
            <div class="ft-title aFlex">
              <span style="margin-left: 10px"
              >参建单位总数:{{ corpData.length }}</span
              >
              <div class="aFlex" style="margin-left: auto">
                <div>参建类型：</div>
                <Select v-model="corpTypeCode" placeholder="请选择企业类型" clearable style="width: 200px;">
                  <Option v-for="(item,index) in corpType" :value="item.code" :key="index">{{ item.name }}</Option>
                </Select>
                <Button type="primary" style="margin-left: 8px;" @click="corpQuery">查询</Button>
              </div>
            </div>
            <Table
                    border
                    size="large"
                    :columns="corpColumns"
                    :data="corpData"
                    highlight-row
            >
              <template slot-scope="{ row, index }" slot="corpName">
            <span class="link-span" style="font-weight: 700">{{
              row.corpName
            }}</span>
                <div>{{ row.corpCode }}</div>
              </template>
              <template slot-scope="{ row, index }" slot="pmName">
                <span class="ft-bold">{{ row.pmName }}</span>
                <div class="ft-gray">{{ row.pmIdCardNumber }}</div>
                <div class="ft-gray">Tel：{{ row.pmPhone }}</div>
              </template>
            </Table>
          </div>
        </TabPane>
        <TabPane label="参建班组" name="3">
          <div class="ft-box">
            <div class="ft-title aFlex">
              <span style="margin-left: 10px">参建班组总数:{{ totalTeam }}</span>
            </div>
            <div>
              <Table
                      border
                      size="large"
                      :columns="corpColumnsBanzu"
                      :data="corpDataBanzu"
                      highlight-row
              >
              </Table>
              <Page
                      class="page"
                      :total="pageTotalTeam"
                      :current.sync="currentPageTeam"
                      :show-total="true"
                      :page-size="pageSizeTeam"
                      @on-change="pageChangeTeam"
              >
              </Page>
            </div>
          </div>
        </TabPane>
        <TabPane label="人员信息" name="4">
          <div class="aFlex fchart-top">
            <span class="ft-bold">请选择查看企业：</span>
            <Select
                    style="width: 200px; margin-left: 15px"
                    @on-change="corpChange"
                    transfer
                    v-model="corpId"
                    placeholder="请选择参建单"
                    clearable
            >
              <Option
                      v-for="(item, index) in corpData"
                      :value="item.corpId"
                      :key="index"
              >{{ item.corpName }}</Option
              >
            </Select>
            <div style="margin-left: 10px">
              <span style="font-weight: 900">累计:</span>
              <p style="font-weight: 900">
              <span>在册人员:{{ workerAttendancefoVO.registerNum }}</span
              >&nbsp;&nbsp;
                <span
                >在册管理人员:{{ workerAttendancefoVO.managerRegister }}</span
                >&nbsp;&nbsp;
                <span
                >在册建筑工人:{{ workerAttendancefoVO.workerRegister }}</span
                >
              </p>
              <p style="font-weight: 900">
              <span>在场人员:{{ workerAttendancefoVO.ondutyNUm }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
                <span>在场管理人员:{{ workerAttendancefoVO.managerOnduty }}</span
                >&nbsp;&nbsp;
                <span>在场建筑工人:{{ workerAttendancefoVO.workerOnduty }}</span>
              </p>
            </div>
          </div>
          <div class="fchart-box" >
            <div class="aFlex fchart-box-top">
              <span class="ft-bold">人员列表</span>
              <div style="margin: auto">
                <Page
                        size="small"
                        :current="page_per"
                        :total="total_per"
                        :page-size="size"
                        @on-change="changePage_per"
                        prev-text="上一页"
                        next-text="下一页"
                />
              </div>
              <div>
                <span>姓名:</span>
                <Input
                        style="width: 186px"
                        v-model="name"
                        placeholder="请输入人员姓名"
                        @on-change="inputChange(name)"
                ></Input>
              </div>
              <RadioGroup
                      v-model="workRole"
                      @on-change="getPersonListChangeType"
                      style="margin-left: 5px"
              >
                <Radio :label="0">全部</Radio>
                <Radio :label="10">管理人员</Radio>
                <Radio :label="20">建筑工人</Radio>
              </RadioGroup>
              <RadioGroup v-model="personType" @on-change="getPersonListChange">
                <Radio :label="1">在场人员</Radio>
                <Radio :label="2">在册人员</Radio>
              </RadioGroup>
            </div>
            <ul class="table-list-wrapper">
              <Spin fix v-if="personLoading"></Spin>
              <li
                      class="list-no-data"
                      v-if="!perData || (perData && perData.length === 0)"
              >
                暂无数据
              </li>
              <li class="tp-item" v-for="(item, index) in perData" :key="index">
                <div class="aFlex">
                  <Avatar size="42" icon="ios-person"></Avatar>
                  <div class="tp-user">
                    <span class="tp-txt-bold">{{ item.workerName }}</span>
                    <div>{{ item.idCardNumber }}</div>
                  </div>
                </div>
                <div class="tp-main">
                  <p>
                    <span class="tp-txt-bold">{{ item.workRole }}</span>
                  </p>
                  <p>公司:&nbsp;&nbsp;{{ item.corpName }}</p>
                  <p>班组:&nbsp;&nbsp;{{ item.teamName }}</p>
                  <p>电话:&nbsp;&nbsp;{{ item.cellPhone }}</p>
                  <p>
                  <span @click.stop="handleCalendar(item.workerId)">
                    <Icon class="tp-calendar" type="md-calendar" />
                    <span>查看考勤日历</span>
                  </span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </TabPane>
        <TabPane label="出勤统计趋势" name="5">
          <div class="fchart-box">
            <div class="aFlex fchart-box-top">
              <span class="ft-bold">出勤统计</span>
              <div class="fchart-top-right aFlex">
                <div>
                  <span>出勤总人数：</span>
                  <span class="ft-gray">{{ cqTotal }}人</span>
                </div>
                <div style="margin-left: 50px; width: 500px; position: relative">
                  <el-date-picker
                          class="marL"
                          v-model="startDateTwo"
                          type="date"
                          :picker-options="pickerOptions"
                          placeholder="请选择"
                          @change="handleStartDateTwo"
                  >
                  </el-date-picker>
                  <el-date-picker
                          class="marL"
                          v-model="endDateTwo"
                          type="date"
                          :picker-options="pickerOptionsend"
                          placeholder="请选择"
                          @change="handleEndDateTwo"
                  >
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="fchart-bi" ref="checkLine">出勤统计</div>
          </div>
        </TabPane>
        <TabPane label="出勤率统计" name="6">
          <div class="ft-box">
            <div class="ft-title aFlex" style="justify-content: space-between">
              <div>
                <span style="margin-left: 10px">今日出勤率:{{ attendanceRate }}</span>
              </div>
              <div style="margin-right: 60px">
                <Form
                        ref="formInline"
                        :model="formInline"
                        inline
                        class="formList"
                        :label-width="100"
                >
                  <FormItem label="出勤时间:">
                <span style="display: inline-block; margin-left: -10px">
                  <Tooltip
                          p
                          effect="dark"
                          content="提示最多选择30日"
                          placement="top-start"
                  >
                    <Icon type="ios-help-circle-outline"></Icon>
                  </Tooltip>
                </span>
                    <DatePicker transfer
                            v-model="formInline.startDate"
                            style="width:200px"
                            type="date"
                            placeholder="请选择起始日期"
                            @on-change="handleStartDate"
                            split-panels
                            class="dataClass"
                            :options="{
                    disabledDate: disabledDateStart,
                  }"
                    ></DatePicker>

                    <DatePicker transfer
                            v-model="formInline.endDate"
                            type="date"
                            placeholder="请选择结束日期"
                            @on-change="handleEndDate"
                            split-panels
                            class="dataClass"
                            :options="{
                    disabledDate: disabledDateEnd,
                  }"
                    ></DatePicker>
                  </FormItem>
                  <Button style="float: right" type="primary" @click="handleQuery"
                  >查询</Button
                  >
                </Form>
              </div>
            </div>
            <div>
              <Table
                      border
                      size="large"
                      :columns="corpColumnsData"
                      :data="corpDataTable"
                      highlight-row
              >
              </Table>
              <Page
                      class="page"
                      :total="totalCountRejest"
                      :page-size="pageSizeRejest"
                      :current="pageRejest"
                      @on-change="changePageRejest"
              >
              </Page>
            </div>
          </div>
        </TabPane>
        <TabPane label="工资统计" name="7">
          <div class="fchart-box">
            <div class="aFlex fchart-box-top">
              <span class="ft-bold">工资发放情况</span>
              <div class="fchart-top-right aFlex">
                <div style="width: 150px; position: relative">
                  <DatePicker transfer
                          type="year"
                          placement="bottom-end"
                          placeholder="请选择"
                          :value="currYear"
                          :clearable="false"
                          @on-change="getSalary"
                  ></DatePicker>
                </div>
              </div>
            </div>
            <div class="fchart-bi" ref="salaryBar">工资发放情况</div>
          </div>
        </TabPane>
      </Tabs>
      <Modal
        v-model="calendarModel"
        footer-hide
        class-name="centerModal"
        width="auto"
      >
        <calen-dar
          v-if="calendarModel"
          :workerId="workerId"
          :corpId="corpId"
          :projectId="projectId"
        ></calen-dar>
      </Modal>
    </div>
  </Layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { projectCorps, projectKeyPositionWorker, projectKeyPositionWorkerExport } from '@/api/platform'
import calenDar from '@/components/calenDar.vue';
import { format } from '../../utils/forMat';
// import dataTime from "@/components/dataTimeMixin";
export default {
  components: {
    'calen-dar': calenDar,
  },
  //   mixins: [dataTime],
  data() {
    return {
      open1: true,
      open2: true,
      open3: true,
      open4: true,
      open5: true,
      formInline: {
        endDate: '',
        startDate: '',
      },
      //总页数
      totalCount: 0,
      //项目id
      projectId: '',
      // 参建单位id
      corpId: '',
      // 工人id
      workerId: '',
      // 在场1 在册2
      personType: 1,
      //建筑工人类型
      workRole: 0,
      // 人员列表
      personLoading: false,
      personLoadingBanzu: false,
      page_per: 1,
      total_per: 0,
      size: 8,
      //出勤率
      attendanceRate: '',
      perData: [],
      // 日历模态框
      calendarModel: false,
      // 出勤统计
      checkLine: null,
      cqTotal: 0,
      // 工资发放
      salaryBar: null,
      // 项目基本信息
      formData: {
        address: '',
        areaName: '',
        buildCorpCode: '',
        buildCorpName: '',
        builderLicenseNum: '',
        buildingArea: '',
        category: '',
        completeDate: '',
        contractorCorpCode: '',
        contractorCorpName: '',
        description: '',
        functionNum: '',
        linkMan: '',
        linkPhone: '',
        nationNum: '',
        prjStatus: '',
        prjsize: '',
        projectId: '',
        projectName: '',
        propertyNum: '',
        regState: '',
        startDate: '',
        winUnit: '',
      },
      //班组总数
      totalTeam: '',
      //班组信息
      pageTotalTeam: 0,
      pageSizeTeam: 10,
      currentPageTeam: 1,
      formDataRegister: {
        name: '',
        buildPermitCode: '',
        areaName: '',
        projectType: '',
        prjStatus: '',
        startDate: '',
        completeDate: '',
        invest: '',
        buildingArea: '',
        contractorCorpName: '',
        contractorCorpCode: '',
        pmName: '',
        pmPhone: '',
        buildCorpName: '',
        buildCorpCode: '',
        supervisingEngineerName: '',
        supervisingEngineerPhone: '',
        adminName: '',
        adminId: '',
        projectDirector: '',
        projectDirectorPhone: '',
        equipmentCompanyName: '',
        equipmentCompanyMobile: '',
        applicantName: '',
        applicantMobile: '',
        email: '',
        remark: '',
      },
      // 项目参建单位
      corpColumns: [
        {
          title: '企业名称',
          slot: 'corpName',

          minWidth: 80,
        },
        {
          title: '参建类型',
          key: 'corpType',
        },
        {
          title: '项目负责人',
          slot: 'pmName',

          minWidth: 80,
        },
        {
          title: '在册人数',
          key: 'regCount',
        },
        {
          title: '在场人数',
          key: 'atWorkCount',
        },
        {
          title: '进场时间',
          key: 'entryTime',
        },
        {
          title: '退场时间',
          key: 'exitTime',
        },
      ],
      //出勤统计
      corpColumnsData: [
        {
          title: '序号',
          type: 'index',
          width: 70,
          fixed: 'left',
        },
        { title: '考勤日期', key: 'attendanceDate', minWidth: 180 },
        {
          title: '在册人数',
          key: 'registerNum',
          minWidth: 180,
          tooltip: true,
        },
        { title: '在场人数', key: 'ondutyNUm', minWidth: 100, tooltip: true },
        {
          title: '出勤人数',
          key: 'attendanceNUm',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '出勤率',
          key: 'attendanceRate',
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '在场管理人员',
          key: 'managerOnduty',
          minWidth: 140,
          tooltip: true,
        },
        {
          title: '出勤管理人员',
          key: 'managerAttendance',
          minWidth: 140,
          tooltip: true,
        },
        {
          title: '管理人员到岗率',
          key: 'managerAttendanceRate',
          minWidth: 140,
        },
        { title: '在场建筑工人', key: 'workerOnduty', minWidth: 140 },
        { title: '出勤建筑工人', key: 'workerAttendance', minWidth: 140 },
        {
          title: '建筑工人到岗率',
          key: 'workerAttendanceRate',
          minWidth: 140,
          tooltip: true,
        },
      ],
      //参建班组
      corpColumnsBanzu: [
          {
              title: "班组ID",
              key: "id",
              width: 100,
              align: "left"
          },
        {
          title: '班组名称',
          //   slot: "teamName",
          key: 'teamName',

          minWidth: 80,
        },
        {
          title: '企业名称',
          key: 'corpName',
        },
        {
          title: '班组长',
          //   slot: "workerName",
          key: 'workerName',

          minWidth: 80,
        },
        {
          title: '在场人数',
          //   slot: "workerName",
          key: 'ondutyNum',

          minWidth: 80,
        },
        {
          title: '进场日期',
          key: 'entryTime',
        },
        {
          title: '退场日期',
          key: 'exitTime',
        },
      ],
      workerAttendancefoVO: {},
      corpDataBanzu: [],
      endDateTwo: '',
      startDateTwo: '',
      pickerOptions: {
        disabledDate: (time) => {
          if (!this.endDateTwo) {
            return false;
          }
          return (
            new Date(this.endDateTwo).getTime() -
              time.getTime() -
              30 * 24 * 60 * 60 * 1000 >
            0
          );
        },
      },

      pickerOptionsend: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      //人员出勤列表
      totalCountRejest: 0,
      pageSizeRejest: 10,
      pageRejest: 1,
      corpData: [],
      //出勤列表
      corpDataTable: [],
      currYear: '',
      currMonth: '',
      //新增搜索条件姓名
      name: '',
      projectForm: {
        projectId: '',
        projectName: '', // 项目名称
        token: '',
        provider: '',
      },
      ruleValidate: {
        projectName: [
          {
            required: true,
            message: '请输入项目名称关键字',
            trigger: 'blur',
          },
        ],
        token: [
          {
            required: true,
            message: '请输入token校验',
            trigger: 'blur',
          },
        ],
        provider: [
          {
            required: true,
            message: '请输入provider校验',
            trigger: 'blur',
          },
        ],
      },
      projects: [],
      projectLoading: false,
      isformData: false,
        // 参建单位表格 <
        corpLoading: false,
        corpTypeCode: '',
        // >
        // 关键岗位人员信息 <
        uploading: false,
        workDate: '',
        registerInfo: [],
        uploadInfo: [],
        registerColumns:[
            { title: '岗位', key: 'manageType', align:'center' },
            { title: '姓名', key: 'workerName', align:'center' },
            { title: '联系电话', key: 'cellPhone', align:'center' },
        ],
        uploadColumns:[
            { title: '序号', type: 'index', width: 70, align: 'center' },
            { title: '姓名', key: 'workerName', align:'center', minWidth: 100 },
            { title: '岗位类型', key: 'manageType', align:'center', minWidth: 120 },
            { title: '预警类型', slot: 'warningType', align:'center', minWidth: 150 },
            { title: '人员状态', key: 'workerStatus', align:'center', minWidth: 100 },
            { title: '性别', key: 'gender', align:'center', minWidth: 100 },
            { title: '身份证号', key: 'idCardNumber', align:'center', minWidth: 150 },
            { title: '项目编号', key: 'projectId', align:'center', minWidth: 120 },
            { title: '项目名称', key: 'projectName', align:'center', minWidth: 150 },
            { title: '项目所在地', key: 'areaName', align:'center', minWidth: 120 },
            { title: '所属单位', key: 'corpName', align:'center', minWidth: 120 },
            { title: '参建类型', key: 'corpType', align:'center', minWidth: 120 },
            { title: '进退场时间', slot: 'entryDate', align:'center', minWidth: 180 },
            { title: '是否到岗', key: 'isOnDuty', align:'center', minWidth: 180 },
            { title: '考勤日期', key: 'attendanceDate', align:'center', minWidth: 180 },
        ],
    };
  },
  computed: {
      ...mapGetters(['corpType']),
  },
  created() {
      this.GetDict();
    const date = new Date();
    let year = date.getFullYear() + '';
    let month = date.getMonth() + 1;
    month = month > 9 ? month : '0' + month;
    this.currYear = year;
    this.currMonth = `${year}-${month}`;
    //   this.getPageData();
    //   //班组信息
    //   this.getcorpDataBanzuData();
    //   //获取登记详情
    //   this.getPageregisterData();
    //   //出勤统计列表
    //   this.getAttendanceStatisticsList();
    //   this.getPersonListChange(this.personType);
    //   this.getPersonListChangeType(this.workRole);
    //   this.inputChange(this.name);
    this.formInline.endDate = new Date();
    this.formInline.startDate = new Date(
      new Date().getTime() - 7 * 24 * 60 * 60 * 1000
    );
    this.startDateTwo = new Date(
      new Date().getTime() - 30 * 24 * 60 * 60 * 1000
    );
    this.endDateTwo = new Date();
  },
  mounted() {
    //引入echarts 初始化图标
    let echarts = require('echarts');
    // 出勤统计
    this.checkLine = echarts.init(this.$refs.checkLine);
    // 工资发放情况
    this.salaryBar = echarts.init(this.$refs.salaryBar);
    //初始化 setOption
    this.initChart();
    //   //获取数据
    //   this.getCheckData();
    //   this.getSalaryData();
    //   window.addEventListener("resize", this.resize);
    //   window.addEventListener("load", this.resize);
    //   /*加载完成自适应*/
    //   this.$nextTick(() => {
    //     this.resize();
    //   });
  },
  watch: {},
  methods: {
      ...mapActions(['GetDict']),
    handleBack(){
      this.$router.push({
        name: 'index',
      });
    },
    getProjects(val) {
      if (val !== undefined && val !== '') {
        this.projectLoading = true;
        this.axios({
          method: 'get',
          url: '/project/management/query',
          params: {
            projectName: val,
          },
        })
          .then((res) => {
            this.projectLoading = false;
            if (res.data.success) {
              this.projects = res.data.data;
            }
          })
          .catch(() => {
            this.projectLoading = false;
          });
      } else {
        this.projects = [];
      }
    },
    searchProject() {
      // this.$Message.success('上传成功');
      // warning
      if (
        this.projectForm.projectId === '' ||
        this.projectForm.projectId === undefined
      ) {
        this.$Message.error('请输入项目名称关键字');
      } else if (
        this.projectForm.token === '' ||
        this.projectForm.token === undefined
      ) {
        this.$Message.error('请输入token校验');
      } else if (
        this.projectForm.provider === '' ||
        this.projectForm.provider === undefined
      ) {
        this.$Message.error('请输入provider校验');
      } else {
        this.axios({
          method: 'get',
          url: '/project/check/query',
          params: {
            projectId: this.projectForm.projectId,
            token: this.projectForm.token,
            provider: this.projectForm.provider,
          },
        })
          .then((res) => {
            if (res.data.success) {
              this.isformData = true;
              this.projectId = this.projectForm.projectId;
              this.getPageData();
              //班组信息
              this.getcorpDataBanzuData();
              //获取登记详情
              this.getPageregisterData();
              //出勤统计列表
              this.getAttendanceStatisticsList();
              this.getPersonListChange(this.personType);
              this.getPersonListChangeType(this.workRole);
              this.inputChange(this.name);

              //获取数据
              this.getCheckData();
              this.getSalaryData();
              window.addEventListener('resize', this.resize);
              window.addEventListener('load', this.resize);
              /*加载完成自适应*/
              this.$nextTick(() => {
                this.resize();
              });
            } else {
              this.$Message.error(res.data.errorMsg);
            }
          })
          .catch(() => {});
      }
    },
    open(e) {
      let t = this;
      e == '1'
        ? (t.open1 = !t.open1)
        : e == '2'
          ? (t.open2 = !t.open2)
          : e == '3'
            ? (t.open3 = !t.open3)
            : e == '4'
              ? (t.open4 = !t.open4)
              : e == '5'
                ? (t.open5 = !t.open5)
                : '';
    },

    //时间选择
    handleStartDate(val) {
      this.formInline['startDate'] = val;
    },
    handleEndDate(val) {
      this.formInline['endDate'] = val;
    },
    // 出勤的时间选择
    handleStartDateTwo(val) {
      this.startDateTwo = val;
      this.getCheckData();
    },
    handleEndDateTwo(val) {
      this.endDateTwo = val;
      this.getCheckData();
    },
    //选择时间
    handleChangeDate(val) {
      this.formInline.startDate = val[0];
      this.formInline.endDate = val[1];
    },
    /* 参建单位改变 */
    corpChange() {
      this.page_per = 1;
      // 人员列表
      this.getPersonList();
      // 图表数据
      this.getCheckData();
      this.getSalaryData();
    },
    // 人员列表
    changePage_per(value) {
      this.page_per = value;
      this.getPersonList();
    },
    //出勤列表
    changePageRejest(value) {
      this.pageRejest = value;
      this.getAttendanceStatisticsList();
    },
    pageChangeTeam(val) {
      this.currentPageTeam = val;
      this.getcorpDataBanzuData();
    },
    // 获取列表
    getPersonListChange(val) {
      this.page_per = 1;
      this.personType = val;
      this.getPersonList();
    },
    getPersonListChangeType(val) {
      this.page_per = 1;
      this.workerId = val;
      this.getPersonList();
    },
    inputChange(val) {
      this.name = val;
      this.getPersonList();
    },
      // 参建单位查询
      corpQuery() {
          this.corpLoading = true;
          projectCorps({
              projectId: this.projectId,
              corpType: this.corpTypeCode || '',
          }).then(res => {
              this.corpLoading = false;
              this.corpData = res.data.data || []
          }).catch(() => {
              this.corpLoading = false;
          })
      },
      timeChange(e) {
          this.workDate = e;
          this.projectKeyPositionWorker();
      },
      // 关键岗位人员信息-导出
      handleWorkerExport() {
          let params = {
              projectId: this.projectId,
              workDate: this.workDate
          };
          projectKeyPositionWorkerExport(params).then((res)=>{
              let fileName = res.headers['content-disposition'];
              let fileNameExport = decodeURI(fileName).split(';')[1].split('=')[1];
              this.common.download(
                  res,
                  fileNameExport,
                  'application/vnd.ms-excel'
              );

          });
      },
      // 关键岗位人员信息
      projectKeyPositionWorker() {
          this.uploading = true;
          projectKeyPositionWorker({
              projectId: this.projectId,
              workDate: this.workDate
          }).then((res)=>{
              this.uploading = false;
              if(res.data.success){
                  this.registerInfo = res.data.data.registerInfo || [];
                  this.uploadInfo = res.data.data.uploadInfo || [];
              }
          }).catch(() => {
              this.uploading = false;
          });
      },
    // 项目基本信息
    getPageData() {
        this.projectKeyPositionWorker();
      this.axios({
        method: 'get',
        url: '/project/detail',
        params: {
          projectId: this.projectId,
        },
      }).then((response) => {
        if (response.data.success) {
          this.corpData = response.data.data.projectUnit;
          this.formData = response.data.data.project;
        }
      });
    },
    // 项目信息登记
    getPageregisterData() {
      this.axios({
        method: 'get',
        url: '/project/projectTokenDetail',
        params: {
          projectId: this.projectId,
        },
      }).then((response) => {
        if (response.data.success && response.data) {
          this.formDataRegister = response.data.data;
        }
      });
    },
    // 出勤统计
    getAttendanceStatisticsList() {
      this.axios({
        method: 'get',
        url: '/project/attendanceDetail',
        params: {
          pageSize: this.pageSizeRejest,
          pageNo: this.pageRejest,
          personType: this.personType,
          corpId: this.corpId || '',
          projectId: this.projectId,
          startDate: this.formInline.startDate,
          endDate: this.formInline.endDate,
        },
      }).then((res) => {
        if (res) {
          this.corpDataTable = res.data.data.datas;
          this.totalCountRejest = res.data.data.totalNum;
          this.attendanceRate = res.data.data.attendanceRate;
        }
      });
    },
    //参建班组
    getcorpDataBanzuData() {
      this.personLoadingBanzu = true;
      this.axios({
        method: 'get',
        url: '/project/teamInfo',
        params: {
          projectId: this.projectId,
          pageNo: this.currentPageTeam,
          pageSize: this.pageSizeTeam,
        },
      }).then((res) => {
        if (res) {
          this.corpDataBanzu = res.data.data.records;
          this.totalTeam = res.data.data.total;
          this.pageTotalTeam = res.data.data.total;
        }
      });
    },
    // 人员列表
    getPersonList() {
      this.personLoading = true;
      this.axios({
        method: 'get',
        url: '/project/workers',
        params: {
          size: 8,
          current: this.page_per,
          personType: this.personType,
          corpId: this.corpId || '',
          projectId: this.projectId,
          workRole: this.workRole,
          name: this.name,
        },
      })
        .then((response) => {
          this.personLoading = false;
          if (response.data.success) {
            this.total_per = response.data.data.total;
            this.perData = response.data.data.records;
            this.workerAttendancefoVO = response.data.data.workerAttendancefoVO;
          }
        })
        .catch(() => {
          this.personLoading = false;
        });
    },
    getCheckData() {
      this.checkLine.showLoading();
      this.axios({
        method: 'get',
        url: '/project/worker/statistics/attendance',
        params: {
          projectId: this.projectId,
          corpId: this.corpId,
          startDate: format(new Date(this.startDateTwo), 'yyyy-MM-dd'),
          endDate: format(new Date(this.endDateTwo), 'yyyy-MM-dd'),
        },
      }).then((response) => {
        this.checkLine.hideLoading();
        if (response.data.success) {
          let zgData = response.data.data.zg;
          let cqData = response.data.data.cq;
          let xData = [];
          this.cqTotal = response.data.data.attendanceNum;
          cqData.map((item) => {
            // this.cqTotal+= Number(item.value);
            xData.push(item.name);
          });
          //   let nowData = format(new Date(), "yyyy-MM-dd");
          //   let nowDataNumber = nowData.substring(nowData.lastIndexOf("-") + 1);
          //   let nowDataMounth = nowData.substring(0, nowData.lastIndexOf("-"));
          //   if (nowDataMounth !== this.currMonth) {
          //     this.checkLine.setOption({
          //       xAxis: {
          //         data: xData,
          //       },
          //       series: [
          //         {
          //           data: zgData,
          //         },
          //         {
          //           data: cqData,
          //         },
          //       ],
          //     });
          //   } else {
          this.checkLine.setOption({
            xAxis: {
              data: xData,
            },
            series: [
              {
                data: zgData,
              },
              {
                data: cqData,
              },
            ],
          });
        }
        // }
      });
    },
    getSalaryData() {
      this.salaryBar.showLoading();
      this.salaryBar.hideLoading();
      this.axios({
        method: 'get',
        url: '/project/worker/statistics/salary',
        params: {
          projectId: this.projectId,
          corpId: this.corpId,
          date: this.currYear,
        },
      }).then((response) => {
        this.salaryBar.hideLoading();
        if (response.data.success) {
          let gzData = response.data.data;
          let xData = [];
          gzData.map((item) => {
            xData.push(item.name + '月');
          });
          this.salaryBar.setOption({
            xAxis: {
              data: xData,
            },
            series: [
              {
                data: gzData,
              },
            ],
          });
        }
      });
    },

    handleQuery() {
      this.getAttendanceStatisticsList();
    },

    handleCalendar(id) {
      this.workerId = id;
      this.calendarModel = true;
    },
    // echarts 适应
    resize() {
      this.checkLine.resize();
      this.salaryBar.resize();
    },
    initChart() {
      this.checkLine.setOption({
        legend: {
          orient: 'horizontal',
          bottom: 15,
          right: 'center',
          icon: 'rect',
        },
        tooltip: {
          trigger: 'axis',
          // formatter: '{a}\n {b}: {c}'
        },
        grid: {
          left: 60,
          right: 30,
          top: 40,
          // bottom: 40
        },
        xAxis: {
          /* 类目轴*/
          type: 'category',
          boundaryGap: false,
          interval: 0,
          axisLabel: {
            interval: 0,
            rotate: 38, //调整数值改变倾斜的幅度（范围-90到90)
          },
          data: [],
        },
        yAxis: {
          name: '单位: 人',
          nameTextStyle: {
            align: 'right',
            // padding:[0]
          },
          splitLine: {
            show: true, //网格线开关
            lineStyle: {
              type: 'dashed',
            },
          },
          axisLine: {
            show: false,
          },
          minInterval: 1,
        },
        color: ['rgba(22,96,218,0.6)', 'rgba(171,18,18,0.6)'],
        series: [
          {
            type: 'line',
            name: '在场人数',
            areaStyle: {
              opacity: 0.4,
            },
            data: [],
          },
          {
            type: 'line',
            name: '出勤人数',
            areaStyle: {
              opacity: 0.4,
            },
            data: [],
          },
        ],
      });
      this.salaryBar.setOption({
        legend: {
          orient: 'horizontal',
          bottom: 15,
          right: 'center',
          icon: 'rect',
        },
        tooltip: {
          // trigger: 'item',
          // formatter: '{a}\n {b}: {c}',
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: 60,
          right: 30,
          top: 40,
          // bottom: 5,
        },
        xAxis: {
          /* 类目轴*/
          type: 'category',
          axisLabel: {
            interval: 0,
          },
          axisTick: {
            alignWithLabel: true,
          },
          data: [],
        },
        yAxis: {
          name: '单位: 元',
          nameTextStyle: {
            align: 'right',
            // padding:[0]
          },
          splitLine: {
            show: true, //网格线开关
            lineStyle: {
              type: 'dashed',
            },
          },
          axisLine: {
            show: false,
          },
          minInterval: 1,
        },
        color: ['#71B1F8'],
        series: [
          {
            type: 'bar',
            name: '发放工资(元)',
            // barGap:'10%',
            barCategoryGap: '10%',
            barMaxWidth: 50,
            data: [],
          },
        ],
      });
    },

    getSalary(str) {
      this.currYear = str;
      this.getSalaryData();
    },

    disabledDateStart(time) {
      return new Date(this.formInline['endDate']).getTime() < time.getTime();
    },
    // 设置默认时间
    disabledDateEnd(time) {
      return time.getTime() > Date.now();
    },
    disabledDateStartTwo(val) {
      return (
        new Date(this.endDateTwo).getTime() <
        val.getTime() - 24 * 60 * 60 * 1000
      );
    },
    disabledDateEndTwo(val) {
      return (
        new Date(this.startDateTwo).getTime() - 24 * 60 * 60 * 1000 >
        val.getTime()
      );
    },
  },
};
</script>
<style scoped>
.projectDetailDockingQuery .not-fchart-bi{
  display: none;
}
/* 顶部导航栏 */
.header-left.ivu-menu-dark {
  background: transparent;
}
.header-left.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item .nav-name {
  padding: 3px 0;
  font-size: 16px;
}
.header-left.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item-active .nav-name {
  border-bottom: 2px solid #ffffff;
}
/* 顶部导航栏 */
.header-left {
  width: 100%;
}
.header-logo:before {
  content: "";
  width: 1px;
  height: 20px;
  position: absolute;
  left: 45px;
  top: 20px;
  background-color: #ffffff;
  z-index: 1;
}
.header-logo {
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  padding-left: 60px;
  background-image: url("../../assets/portal/portal-gh.png");
  background-repeat: no-repeat;
  background-position: 5px center;
  background-size: 30px;
}
/* 页面头部导航栏 */
.header-wrapper {
  background: linear-gradient(
    123deg,
    rgba(36, 104, 203, 1) 0%,
    rgba(36, 104, 203, 1) 0%,
    rgba(10, 59, 130, 1) 100%,
    rgba(10, 59, 130, 1) 100%
  );
  /*height: 64px;*/
  /*line-height: 64px;*/
  padding: 0 15px;
  /*height: 60px;*/
  /*line-height: 60px;*/
}
.ajFlex {
  position: fixed;
  z-index: 1000;
  width: 100%;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}

.layout-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 600px;
}

.ft-search-wrap {
  margin: 30px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.ft-search-wrap .ft-search-name {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}
.ft-search-wrap .ft-search-content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ft-search-wrap .ft-search-content .form-list {
  width: 55%;
}
.ft-search-wrap .ft-search-content .form-list .ivu-form-item {
  display: flex;
  justify-content: flex-end;
}
.ft-search-wrap .ft-search-content .ft-search-btn {
  flex: 1;
  display: flex;
  align-items: flex-end;
}
.ft-search-wrap
  .ft-search-content
  .form-list
  .ivu-form-item
  .ivu-form-item-content
  .red-asterisk {
  display: inline-block;
  margin-right: 5px;
  color: #ed4014;
}
 .red-asterisk {
  width: 6px;
  height: 6px;
  margin-right: 8px;
  color: #ed4014;
}
.projectDetailDockingQuery
  .ft-search-wrap
  .ft-search-content
  .form-list
  > .ivu-form-item:last-child {
  margin-bottom: 0;
}
.ft-search-wrap .ft-search-content .ft-search-btn .ivu-btn {
  margin-left: 80px;
  margin-right: 5px;
  width: 150px;
  height: 40px;
  background: #169bd5;
}

.tp-item {
  width: 25%;
  padding: 12px 18px;
  border-right: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
  font-size: 13px;
  color: #999999;
}
.tp-item {
  cursor: pointer;
}
.tp-item:hover .tp-user {
  text-decoration: underline;
}
.tp-calendar {
  color: #0099ff;
  font-size: 21px;
  cursor: pointer;
}
.tp-calendar:hover {
  background-color: #ebf7ff;
}
.tp-user {
  margin-left: 8px;
}
.tp-txt-bold {
  font-weight: 700;
  margin-right: 10px;
  display: block;
}
.tp-main {
  margin: 10px 0 15px 0;
  line-height: 1.8;
}
.tp-bottom {
  text-align: right;
}
.tp-time {
  color: #cccccc;
  margin-left: 5px;
}
.dataPicker >>> .ivu-select-dropdown {
  /* position: sticky !important; */
  will-change: top, left;
  transform-origin: center bottom;
  /* top: 1200px !important; */
  left: 0px;
}
</style>

<style scoped>
.formList >>> .ivu-form-item {
  margin-bottom: 0;
}
/* .dataClass >>> .ivu-select-dropdown {
  position: absolute;
  left: -145px !important;
} */
.page {
  text-align: right !important;
}
.ft-title,
.aFlex {
  position: relative;
}
.high-search {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}
.search-open,
.search-close {
  margin-left: 0;
}
.fontColor {
  width: 321px;
  height: 14px;
  font-size: 14px;
  padding-left: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #9EA7B4;
  line-height: 25px;
}
.searchStyle {
  width: 80px;
  height: 32px;
  background: #3399FF;
  border-radius: 4px;
}
.titleStyle {
  width: 153px;
  height: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #657180;
}
.red_change {
  display: flex !important;
  align-items: center !important;
}
</style>
